<template>
    <div v-show="show" class="learning-mode bg-effect align-end justify-center">
        <div class="content">
            <div class="description mb-10 word-break">{{currentInfo.text}}</div>

            <div class="justify-between align-center">
                <span>
                    {{positionInfo}}
                </span>

                <div class="btn-group justify-end">
                    <base-button v-show="position"
                                 @click.native.stop="back"
                                 class="mr-5"
                                 padding="9px 24px">
                        <span>{{localizeList.back}}</span>
                    </base-button>
                    <base-button @click.native.stop="next"
                                 class="mr-5"
                                 padding="9px 24px">
                        <span v-if="!learningDone">{{localizeList.next}}</span>
                        <span v-else>{{localizeList.done}}</span>
                    </base-button>
                    <base-button @click.native="hide"
                                 padding="9px 24px">
                        {{localizeList.finish}}
                    </base-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { bus } from '../../../main'
    export default {
        name: "learningMode",
        props: {
            learningInfo: {
                type: Array,
                default: () => []
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                elemSelectors: [
                    // Login
                    {
                        type: 0,
                        backgroundColor: "var(--primary-color)",
                        selector: "div.tour-navbar > div.project-controller > div.login-wrap",
                    },
                    // Tour name
                    {
                        type: 1,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-headline > h2 > span.tour-name",
                    },
                    // Hotel name
                    {
                        type: 2,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content div.hotel-info > div.hotel-name-feature div.hotel-name-wrap > div.flex > h3 > a",
                    },
                    // Hotel fines
                    {
                        type: 3,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content div.hotel-info > div.warning-block.mt-6",
                    },
                    // Flight "see more options"
                    {
                        type: 4,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content .more-options",
                    },
                    // Flight "fare information"
                    {
                        type: 5,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content-wrap > div.basket-content div.flight-info-wrap div.tariff-info[style='']",
                    },
                    // Add. services
                    {
                        type: 6,
                        backgroundColor: "var(--lighten-2-color)",
                        selector: ".block .c-checkbox:not(.disabled):not(.checked)"
                    },
                    // Main tourist lastname
                    {
                        type: 7,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content div.treveler-data-content div.treveler-form > div.field-wrap.lastname"
                    },
                    // Main tourist firstname
                    {
                        type: 8,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content div.treveler-data-content div.treveler-form > div.field-wrap.firstname"
                    },
                    // Main tourist passport
                    {
                        type: 9,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content div.treveler-data-content div.treveler-form > div.field-wrap.passport"
                    },
                    // Main tourist citizenship
                    {
                        type: 10,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content div.treveler-data-content div.treveler-form > div.field-wrap.citizenship"
                    },
                    // Main tourist phone
                    {
                        type: 11,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content div.treveler-data-content div.treveler-form > div.field-wrap.phone"
                    },
                    // Main tourist email
                    {
                        type: 12,
                        backgroundColor: "var(--white-color)",
                        selector: "div.basket-content div.treveler-data-content div.treveler-form > div.field-wrap.email"
                    },
                ],
                currentElem: null,
                position: 0,
            }
        },
        computed: {
            currentInfo() {
                const type = this.elemSelectors[this.position]?.type;
                return this.learningInfo.find(x => x.type === type) || {};
            },
            positionInfo() {
                return `${this.position + 1} ${this.localizeList.of} ${this.elemSelectors.length}`
            },
            learningDone() {
                return this.position >= this.elemSelectors.length - 1
            }
        },
        methods: {
            focusElem() {
                const type = this.currentInfo.type;
                const item = this.elemSelectors.find(x => x.type === type);
                if (!item?.selector) return;

                const elem = document.querySelector(item.selector);
                if (
                    !elem ||
                    type === 4 && elem.innerText !== this.localizeList.seeМoreОptions ||
                    type === 6 && elem.innerText !== this.localizeList.notIncluded
                ) return;

                if (this.currentElem) {
                    this.currentElem.style.backgroundColor = "unset";
                    this.currentElem.classList.remove("learning-focused-element")
                }

                this.currentElem = elem;
                elem.scrollIntoView({block: "center", behavior: "smooth"});
                this.currentElem.style.backgroundColor = item.backgroundColor;
                elem.classList.add("learning-focused-element")
            },
            next() {
                if (this.learningDone) {
                    this.hide();
                    return;
                }

                this.position++;
                this.focusElem();
            },
            back() {
                this.position--;
                this.focusElem();
            },
            hide() {
                this.currentElem.style.backgroundColor = "unset";
                this.currentElem.classList.remove("learning-focused-element");
                this.currentElem = null;
                this.position = 0;
                this.$emit("hide");
            },
            setVisibleElem() {
                const types = this.learningInfo.map(x => x.type);
                this.elemSelectors = this.elemSelectors.filter(x => {
                    const elem = document.querySelector(x.selector);
                    if (
                        !elem ||
                        x.type === 3 && !elem.innerText ||
                        x.type === 4 && elem.children[1].style.opacity === '0' ||
                        x.type === 5 && elem?.style?.display === "none" ||
                        x.type === 6 && elem.innerText !== this.localizeList.notIncluded
                    ) return false;

                    return types.includes(x.type);
                })
            }
        },
        watch: {
            show(val) {
                bus.$emit("learning-mode-show", val);

                if (!val) {
                    window.removeEventListener("click", this.hide);
                    return;
                }

                setTimeout(() => {
                    window.addEventListener("click", this.hide);
                    this.setVisibleElem();
                    this.focusElem();
                },0);
            }
        }
    }
</script>

<style scoped>

    .learning-mode {
        z-index: 99999;
        background-color: rgba(0, 0, 0, .3);
    }

    .content {
        width: 40vw;
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        border-radius: 4px;
        background-color: var(--white-color);
        padding: 20px;
        margin-bottom: 80px;
    }

    .description {
        color: var(--dark-1-color);
        white-space: pre-wrap;
    }



</style>